import './ContextMenu.css';
import React, { FC, RefObject } from 'react';
import { observer } from 'mobx-react-lite';
import { Dropdown, DropdownItem } from './Dropdown';

const DropdownButton: FC = () => (
  <>
    <span className="dot"></span>
    <span className="dot"></span>
    <span className="dot"></span>
  </>
);

export interface MenuItem {
  text: string;
  className?: string;
  icon: string;
  disabled?: boolean;
  onClick: () => void;
}

export interface ContextMenuProps {
  menuItems: MenuItem[];
  scrollingContainerRef?: RefObject<HTMLDivElement>;
  disabled?: boolean;
}

export const ContextMenu: FC<ContextMenuProps> = observer(({menuItems, scrollingContainerRef, disabled = false}) =>
  (
    <Dropdown
      parentRef={ scrollingContainerRef }
      className='context-menu'
      button={ <DropdownButton/> }
      disabled={ disabled }
    >
      { menuItems.map((item) => (
        <DropdownItem
          key={ item.text }
          className={ item.className}
          disabled={ item.disabled || false }
          onClick={ item.onClick }
        >
          <i className={ item.icon }></i>
          { item.text }
        </DropdownItem>
      )) }
    </Dropdown>
  ));
